(function(){
    'use strict';

    angular.module('dataHandlingActionUpdateField', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('actionUpdateFieldCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionUpdateFieldCtrl]);

    function actionUpdateFieldCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayAddWaitTimeActionOptions = false;
        $scope.errors = [];
        $scope.descriptionEmpty = false;

        var sunDay = $scope.translate('timePicker.sun'),
            mon = $scope.translate('timePicker.mon'),
            tue = $scope.translate('timePicker.tue'),
            wed = $scope.translate('timePicker.wed'),
            thu = $scope.translate('timePicker.thrus'),
            fri = $scope.translate('timePicker.fri'),
            sat = $scope.translate('timePicker.sat'),
            jan = $scope.translate('timePicker.jan'),
            feb = $scope.translate('timePicker.feb'),
            mar = $scope.translate('timePicker.mar'),
            apr = $scope.translate('timePicker.apr'),
            may = $scope.translate('timePicker.may'),
            jun = $scope.translate('timePicker.jun'),
            jul = $scope.translate('timePicker.jul'),
            aug = $scope.translate('timePicker.aug'),
            set = $scope.translate('timePicker.set'),
            oct = $scope.translate('timePicker.oct'),
            nov = $scope.translate('timePicker.nov'),
            dec = $scope.translate('timePicker.dec');

        $rootScope.$on('displayActionUpdateFieldModal', function(evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.contactListData = $rootScope.contactListData;
            $scope.showTip = showTip;
            $scope.displayAddWaitTimeActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.errorUnits = false;
            $scope.errorDelay = false;
            $scope.descriptionEmpty = false;
            $scope.setInitListItem();
        });

        $rootScope.$on('hideActionUpdateFieldModal', function() {
            $scope.displayAddWaitTimeActionOptions = false;
        });

        $rootScope.$on('displayActionUpdateFieldModalError', function(evt, errors) {
            $scope.errors = errors;
        });

        $scope.$watch('connections.data.list', (newVal, oldVal) => {
            if(oldVal && oldVal != newVal) {
                $scope.connections.data.fields = [];
            }
        });

        $scope.cancel = function() {
            $scope.displayAddWaitTimeActionOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            // execute listener when user cancel the add the node of delay
            if (!node) {
                $rootScope.$broadcast('deleteUpdateFieldNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            $rootScope.$emit('saveActionUpdateFieldData' + $scope.connections.id, $scope.connections);
        };

        $scope.setInitListItem = () => {

            if(!$scope.connections.data.fields.length) {
                $scope.addToFieldList();
                $scope.connections.data.fields[0].pickedList = $rootScope.journeyLists && $rootScope.journeyLists[0] || '';
                $scope.updateFields();
            } else {
                $scope.updateFields();
            }

            $scope.connections.data.fields.map((i, index) => {
                $timeout(() => {
                    if(i.fieldType == 4) {
                        const id = `#field-date-picker-${index}`;
                        $(id).datetimepicker({
                            stepMinute: 15,
                            minDate: 0,
                            dayNamesMin: [sunDay, mon, tue, wed, thu, fri, sat],
                            monthNames: [jan, feb, mar, apr, may, jun, jul, aug, set, oct, nov, dec],
                            currentText: $scope.translate('timePicker.now'),
                            closeText: $scope.translate('timePicker.done'),
                            amNames: ['AM', 'A'],
                            pmNames: ['PM', 'P'],
                            timeFormat: 'HH:mm',
                            timeSuffix: '',
                            timeOnlyTitle: $scope.translate('timePicker.choooseTime'),
                            timeText: $scope.translate('timePicker.time'),
                            hourText: $scope.translate('timePicker.hour'),
                            minuteText: $scope.translate('timePicker.minute'),
                            secondText: $scope.translate('timePicker.second'),
                            millisecText: $scope.translate('timePicker.millisecond'),
                            microsecText: $scope.translate('timePicker.microsecond'),
                            timezoneText: $scope.translate('timePicker.timeZone')
                        });

                        $(id).on('change', function () {
                            $scope.connections.data.fields[index].updateTo = $(this).val();
                        });
                    }
                }, 500);
            });
        };

        $scope.updateFields = () => {
            canvasService.getFields($scope.connections.data.fields[0].pickedList).then(({data}) => {
                $scope.fieldList = data.Details;
                if(!$scope.connections.data.fields.length) {
                    $scope.connections.data.fields.push({
                        pickedList: '',
                        pickedField: '',
                        pickedFieldName: '',
                        updateTo: '',
                        fieldType: 1
                    });
                }
            })
        };

        $scope.triggerDatePicker = (id) => {
            $timeout(function(){
                document.getElementById(id).focus();
            });
        };

        $scope.updateFieldtype = (index) => {
             const dataField = $scope.fieldList.find((i) => {
                return i.FieldKey == $scope.connections.data.fields[index].pickedField;
            });
            const newType = dataField['FieldType'] || 1;
            $scope.connections.data.fields[index].pickedFieldName = dataField.FieldName;

            if( $scope.connections.data.fields[index].fieldType != newType) {
                $scope.connections.data.fields[index].fieldType = 8;
                $timeout(() => {
                    $scope.connections.data.fields[index].fieldType = newType;
                    $scope.connections.data.fields[index].updateTo = '';
                }, 300);

                $timeout(() => {
                    if(newType == 4) {
                        const id = `#field-date-picker-${index}`;
                        $(id).datetimepicker({
                            stepMinute: 15,
                            minDate: 0,
                            dayNamesMin: [sunDay, mon, tue, wed, thu, fri, sat],
                            monthNames: [jan, feb, mar, apr, may, jun, jul, aug, set, oct, nov, dec],
                            currentText: $scope.translate('timePicker.now'),
                            closeText: $scope.translate('timePicker.done'),
                            amNames: ['AM', 'A'],
                            pmNames: ['PM', 'P'],
                            timeFormat: 'HH:mm',
                            timeSuffix: '',
                            timeOnlyTitle: $scope.translate('timePicker.choooseTime'),
                            timeText: $scope.translate('timePicker.time'),
                            hourText: $scope.translate('timePicker.hour'),
                            minuteText: $scope.translate('timePicker.minute'),
                            secondText: $scope.translate('timePicker.second'),
                            millisecText: $scope.translate('timePicker.millisecond'),
                            microsecText: $scope.translate('timePicker.microsecond'),
                            timezoneText: $scope.translate('timePicker.timeZone'),
                        });
                        $(id).on('change', function () {
                            $scope.connections.data.fields[index].updateTo = $(this).val();
                        });
                    }
                }, 500);
            }
        };

        let height = 431;
        $scope.addToFieldList = () => {
            $timeout(() => {
                height += 300;
                document.getElementById(`field-modal-${$scope.connections.id}`).scrollTop = height;
            }, 300);

            $scope.connections.data.fields.push({
                pickedList: '',
                pickedField: '',
                pickedFieldName: '',
                updateTo: '',
                fieldType: 1
            });
        };

        $scope.deleteFieldSet = ($index) => {
            $scope.connections.data.fields.splice($index, 1);
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/actionUpdateFieldController.js